import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: false
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  /**
   * Marks the entire markup as "safe" HTML.
   *
   * This should only be used by markup returned by the back end, which has already been sanitized and can
   * be treated as safe.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: any, args?: any): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

}
